import { 
    Component, 
    Input, 
    OnInit 
} from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { BaseComponent } from "app/base-module/base-component/base.component";

import { ClienteModel } from "app/clientes/models/cliente.model";

@Component({
  selector: "cliente-renda-variavel-perfil",
  templateUrl: "./cliente-renda-variavel-perfil.component.html",
  styleUrls: ["./cliente-renda-variavel-perfil.component.scss"]
})

export class ClienteRendaVariavelPerfilComponent 
    	extends BaseComponent 
        implements OnInit 
{

    @Input() client!: ClienteModel;

    constructor( 
        public dialog: MatDialog, 
        override snackBar: MatSnackBar) 
    { 
        super(dialog, snackBar);
    }

    ngOnInit() {
    }

}
